// extracted by mini-css-extract-plugin
export var box = "TraineeSuccessModal-module--box--d3ad1";
export var box_md = "TraineeSuccessModal-module--box_md--986e2";
export var box_xmd = "TraineeSuccessModal-module--box_xmd--0ef8c";
export var box_flex = "TraineeSuccessModal-module--box_flex--a6171";
export var box_lg = "TraineeSuccessModal-module--box_lg--28613";
export var box_sm = "TraineeSuccessModal-module--box_sm--d45e9";
export var box_outer = "TraineeSuccessModal-module--box_outer--62ca2";
export var box_whiteBg = "TraineeSuccessModal-module--box_white-bg--98b1d";
export var box_noMarginBottom = "TraineeSuccessModal-module--box_no-margin-bottom--aa6f2";
export var box_noPadding = "TraineeSuccessModal-module--box_no-padding--8643e";
export var box_outerGray = "TraineeSuccessModal-module--box_outer-gray--8546e";
export var box_dark = "TraineeSuccessModal-module--box_dark--6a607";
export var box_zIndex = "TraineeSuccessModal-module--box_z-index--7ee03";
export var box_zIndex6 = "TraineeSuccessModal-module--box_z-index-6--6f18f";
export var box_eventsWithLine = "TraineeSuccessModal-module--box_events-with-line--8966a";
export var box_featuresAo = "TraineeSuccessModal-module--box_features-ao--f3367";
export var box_verticalPaddings = "TraineeSuccessModal-module--box_vertical-paddings--18b43";
export var clearP = "TraineeSuccessModal-module--clearP--ec1a0";
export var clearP_vc = "TraineeSuccessModal-module--clearP_vc--0475b";
export var text = "TraineeSuccessModal-module--text--0bad6";
export var subtext = "TraineeSuccessModal-module--subtext--e4857";
export var email = "TraineeSuccessModal-module--email--3b32f";
export var icon = "TraineeSuccessModal-module--icon--beb3e";
export var extendedContent = "TraineeSuccessModal-module--extendedContent--ab8fd";
export var extendedTitle = "TraineeSuccessModal-module--extendedTitle--3723a";
export var extendedText = "TraineeSuccessModal-module--extendedText--6bf16";
export var fadeInAnimation = "TraineeSuccessModal-module--fadeInAnimation--4eaab";
export var placeHolderShimmer = "TraineeSuccessModal-module--placeHolderShimmer--71004";